import Vue from 'vue';
import Router from 'vue-router';
import { TokenService } from '../services/token.service';
import ApiService from '../services/api.service';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: () => import('../views/public/Landing.vue'),
    meta: {
      public: true,
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/registro',
    name: 'RegistroAlumno',
    component: () => import('../views/public/RegistroAlumno.vue'),
    meta: {
      public: true
    }
  },
  {
    path: '/resetPassword',
    name: 'Reestablecer Password',
    component: () => import('../views/public/RecuperaPassword.vue'),
    meta: {
      public: true
    }
  },
  {
    path: '/resetCuenta',
    name: 'Reestablecer Cuenta',
    component: () => import('../views/public/ResetAccount.vue'),
    meta: {
      public: true
    }
  },
  {
    path: '*',
    component: () => import('../views/public/404')
  },
  {
    path: '/usuario',
    component: () => import('@/layouts/user/Index.vue'),
    children: [
      {
        path: '',
        redirect: 'trabajos'
      },
      {
        path: 'trabajos',
        name: 'Trabajos',
        component: () => import('../views/user/Trabajos')
      },
      {
        path: 'perfil',
        name: 'Perfil',
        component: () => import('../views/user/Perfil')
      },
      {
        path: 'publicaciones',
        name: 'Publicaciones',
        component: () => import('../views/user/Publicaciones')
      },
      {
        path: 'prueba',
        name: 'Test',
        component: () => import('../views/user/Prueba')
      }
    ]
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('../views/admin/Login'),
    meta: {
      public: true,
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/admin',
    component: () => import('@/layouts/admin/Index.vue'),
    children: [
      {
        path: '',
        redirect: 'perfil'
      },
      {
        path: 'dashboard',
        name: 'Dashboard Admin',
        component: () => import('../views/admin/Dashboard'),
        meta: {
          menuIndex: 0,
          restricted: true
        }
      },
      {
        path: 'alumnos',
        name: 'Alumnos Admin',
        component: () => import('../views/admin/Alumnos'),
        meta: {
          menuIndex: 1,
          restricted: true
        }
      },
      {
        path: 'reclutadores',
        name: 'Reclutadores Admin',
        component: () => import('../views/admin/Reclutadores'),
        meta: {
          menuIndex: 2,
          restricted: true
        }
      },
      {
        path: 'administradores',
        name: 'Administradores Admin',
        component: () => import('../views/admin/Administradores'),
        meta: {
          menuIndex: 4,
          restricted: true
        }
      },
      {
        path: 'perfil',
        name: 'Administradores Perfil',
        component: () => import('../views/admin/Perfil'),
        meta: {
          restricted: true
        }
      },
      {
        path: 'carga',
        name: 'Carga Masiva',
        component: () => import('../views/admin/CargaMasiva'),
        meta: {
          menuIndex: 3,
          restricted: true
        }
      },
      {
        path: 'news',
        name: 'Noticias',
        component: () => import('../views/admin/News'),
        meta: {
          menuIndex: 5,
          restricted: true
        }
      }
      // {
      //  path: 'estadisticas',
      //  name: 'Estadísticas',
      //  component: () => import('../components/admin/Estadísticas')
      // }
    ]
  },
  {
    path: '/empresas/registro',
    name: 'RegistroEmpresa',
    component: () => import('../views/company/RegistroEmpresa'),
    meta: {
      public: true
    }
  },
  {
    path: '/empresas/',
    component: () => import('@/layouts/empresa/Index.vue'),
    children: [
      {
        path: 'inicio',
        name: 'Inicio Empresas',
        component: () => import('@/views/company/InicioEmpresa.vue'),
        meta: {
          menuIndex: 0
        }
      },
      {
        path: 'crear',
        name: 'Crear Propuesta Empresas',
        component: () => import('@/views/company/CrearPropuesta.vue'),
        meta: {
          menuIndex: 1
        }
      },
      {
        path: 'perfil',
        name: 'Perfil Empresas',
        component: () => import('@/views/company/PerfilEmpresa.vue')
      }
    ]
  },
  {
    path: '/noticia/:id',
    name: 'NoticiaDetalle',
    component: () => import('../views/public/Noticia.vue'),
    meta: {
      public: true
    }
  }
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public);
  const loggedIn = !!TokenService.getToken();
  // debugger;
  if (loggedIn) {
    if (isPublic) {
      next();
    } else {
      if (!ApiService.getHeader()) {
        ApiService.setHeader().then(() => {
          next();
        });
      }
    }
  } else {
    if (isPublic) {
      next();
    } else {
      if (to.path.includes('admin')) next('/admin/login');
      else next('/');
    }
  }
  next();
});

export default router;
